import { DmConversation } from "@adalong/schemas";
import { CRMTemplateView } from "common";

const campaignUrlPlaceholder = '[url]';
const termsUrlPlaceholder = '[terms]';
const hashtagPlaceholder = '#[hashtag]';

// Function to process template content and replace variables
export const processTemplateContent = ({
    content,
    currentTemplate,
    creatorHandle,
    termsUrl = ''
}: {
    content: string;
    currentTemplate?: CRMTemplateView;
    creatorHandle?: string;
    termsUrl?: string;
}): { processedContent: string; warnings: string[]; } => {
    let processedContent = content;
    const warnings: string[] = [];
    // const currentTemplate = template || selectedTemplate;

    if (creatorHandle) {
        // Ensure we have @ prefix
        const formattedHandle = creatorHandle.startsWith('@') ? creatorHandle : `@${creatorHandle}`;
        processedContent = processedContent.replace(/\@\[creator\]/g, formattedHandle);
    } else {
        // Fallback to empty string if no creator data
        processedContent = processedContent.replace(/\@\[creator\]/g, '');
    }

    // Replace [url] with URL from template
    if (processedContent.includes(campaignUrlPlaceholder)) {
        const websiteUrl = currentTemplate?.url ?? '';
        if (!websiteUrl || websiteUrl.includes('placeholder') || websiteUrl.includes('example')) {
            warnings.push('Campaign URL is not properly configured');
        }
        processedContent = processedContent.replace(/\[url\]/g, websiteUrl ?? '');
    }

    // Replace [terms] with terms URL from template or group (template takes priority)
    if (processedContent.includes(termsUrlPlaceholder)) {
        if (!termsUrl || termsUrl.includes('placeholder') || termsUrl.includes('example')) {
            warnings.push('Terms URL is not properly configured');
        }
        processedContent = processedContent.replace(/\[terms\]/g, termsUrl);
    }

    // Replace #[hashtag] with hashtag from template
    if (processedContent.includes(hashtagPlaceholder)) {
        const hashtagValue = currentTemplate?.hashtag || '';
        processedContent = processedContent.replace(/#\[hashtag\]/g, hashtagValue ? `#${hashtagValue}` : '');
    }

    return {
        processedContent,
        warnings
    }
};

export const extractCreatorHandle = (
    creatorName?: string, 
    conversation?: DmConversation
): string => {
    let creatorHandle = '';

    // Priority 1: Use creatorName prop if available
    if (creatorName) {
        creatorHandle = creatorName;
    }
    // Priority 2: Use conversation data if available
    else if (conversation?.conversationTarget) {
        creatorHandle = conversation.conversationTarget.name || 
                        conversation.conversationTarget.id;
    }

    // Ensure we have @ prefix
    return creatorHandle.startsWith('@') ? creatorHandle : `@${creatorHandle}`;
};
